import React, { useEffect, useState } from 'react'
import classes from './offersPage.module.css';
import Button from '../../components/Button/Button';
import { getRevlumOffers } from '../../services/revlumService';
import { getWannadsOffers } from '../../services/wannadsService';
import { getUserGeo } from '../../services/userGeoService';
import { getCpaLeadOffers } from '../../services/cpaLeadService';
import axios from 'axios';
import { useAuth } from '../../hooks/useAuth';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import WallOffer from '../../components/WallOffer/WallOffer';
import TopOffer from '../../components/TopOffer/TopOffer';
import { getAdscendOffers } from '../../services/adscendService';
import { getToroxGamingOffers, getToroxOffers, toCardOffer } from '../../services/toroxService';
import CategorySelector from './CategorySelector';
import DeviceFilter from './DeviceFilter';
import JackpotStrip from '../../components/JackpotStrip/JackpotStrip';
import useDarkOffersBackground from '../../hooks/useDarkOffersBackground';
import { getPlayingNow } from '../../utils/playingNow';
import { DEVICE_FILTERS, filterOffersByDeviceFilter, filterOffersByPlatform, getUserPlatform, PLATFORMS } from '../../utils/device';
import { buildCpxProfileParams, buildRapidoLocale, buildRapidoDOB, buildRapidoGender } from '../../utils/profile';
import { getRapidoReachSurveys, normalizeRapidoSurvey } from '../../services/rapidoreachService';


export default function OffersPage() {
    const { user } = useAuth();
    const [ip, setIP] = useState("");
    const [city, setCity] = useState("");
    const [gamingOffers, setGamingOffers] = useState([]);
    const [offers, setOffers] = useState([]);
    const [country, setCountry] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [surveys, setSurveys] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [deviceFilter, setDeviceFilter] = useState(() => {
        const p = getUserPlatform();
        return p === PLATFORMS.DESKTOP ? DEVICE_FILTERS.ALL : p;
    });
    useDarkOffersBackground();

    useEffect(() => {
      const fetchIPAndCountry = async () => {
          try {
              const ipRes = await axios.get("https://api.ipify.org/?format=json");
              const fetchedIP = ipRes.data.ip;
              setIP(fetchedIP);

              const geoRes = await getUserGeo(fetchedIP);
              const fetchedCountry = geoRes.country_code2;
              setCountry(fetchedCountry);
              if (geoRes.city) setCity(geoRes.city);

              console.log("User IP is " + fetchedIP);
              console.log("User country is " + fetchedCountry);
          } catch (error) {
              setError(error.message ? error.message : JSON.stringify(error));
              setLoading(false);
          }
      };

      fetchIPAndCountry();
  }, []);

  useEffect(() => {
      const fetchOffers = async () => {
          if (user?.id && ip && country) {
              try {
                  const [toroxGameData, toroxOfferData] = await Promise.all([
                      getToroxGamingOffers(country),
                      getToroxOffers(country)
                  ]);

                    const toroxArray = toroxGameData.data.offers;
                    const sortedOffers = toroxArray.sort((a, b) => b.conversion_rate - a.conversion_rate);
                    const top30Offers = sortedOffers.slice(0, 30);
                    const transformToroxGames = top30Offers.map(offer => toCardOffer(offer, user.id, country));

                    const toroxOfferArray = toroxOfferData.data.offers;
                    const sortedRegularOffers = toroxOfferArray.sort((a, b) => b.conversion_rate - a.conversion_rate).slice(0, 30);
                    const transformToroxOffers = sortedRegularOffers.map(offer => toCardOffer(offer, user.id, country));

              const allGames = [...transformToroxGames];
              const uniqueGames = Array.from(new Set(allGames.map(offer => offer.title)))
                                  .map(title => allGames.find(offer => offer.title === title));
              const allOffers = [...transformToroxOffers];
              const uniqueOffers = Array.from(new Set(allOffers.map(offer => offer.title)))
                                  .map(title => allOffers.find(offer => offer.title === title));
              const platform = getUserPlatform();
              setGamingOffers(filterOffersByPlatform(uniqueGames, platform));
              setOffers(filterOffersByPlatform(uniqueOffers, platform));
              } catch (error) {
                  setError(error.message ? error.message : JSON.stringify(error));
              } finally {
                  setLoading(false);
              }
          }
          };
          fetchOffers();
  }, [user?.id, ip, country]);

    useEffect(() => {
        if (!user?.id || !ip) return;

        let cancelled = false;

        const fetchSurveys = async () => {
            try {
                const cpxPromise = fetch(
                    `https://live-api.cpx-research.com/api/get-surveys.php?app_id=21139&ext_user_id=${user.id}&output_method=api&ip_user=${ip}&limit=30${buildCpxProfileParams(user)}`
                ).then(r => r.json());
                // City is required by RapidoReach — skip it (not CPX) when geo lookup failed.
                const rapidoPromise = city
                    ? getRapidoReachSurveys({
                        userId: user.id,
                        ipAddress: ip,
                        city,
                        countryLanguageCode: buildRapidoLocale(user),
                        dateOfBirth: buildRapidoDOB(user),
                        gender: buildRapidoGender(user),
                        zipCode: user?.zipCode,
                    })
                    : Promise.resolve(null);
                const [cpxRes, rapidoResult] = await Promise.allSettled([cpxPromise, rapidoPromise]);
                if (!cancelled) {
                    const cpxSurveys = cpxRes.status === 'fulfilled' && Array.isArray(cpxRes.value?.surveys)
                        ? cpxRes.value.surveys : [];
                    const rapidoSurveys = rapidoResult.status === 'fulfilled' && Array.isArray(rapidoResult.value?.Data)
                        ? rapidoResult.value.Data.map(normalizeRapidoSurvey) : [];
                    setSurveys([...cpxSurveys, ...rapidoSurveys]);
                }
            } catch (error) {
                if (!cancelled) {
                    setError(error.message ? error.message : JSON.stringify(error));
                }
            }
        };

        fetchSurveys();
        return () => {
            cancelled = true;
        };
    }, [user?.id, user?.birthDay, user?.birthMonth, user?.birthYear, user?.gender, user?.countryCode, user?.zipCode, ip, city]);

    // Update screenWidth when window resizes
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Adjust number of items based on screen width. Dot navigation caps at
    // 10 items so the dots always fit on one row (dots = ceil(n / scroll)).
    const narrowScreens = screenWidth <= 768;
    const visibleGamingOffers = filterOffersByDeviceFilter(gamingOffers, deviceFilter);
    const topGames = visibleGamingOffers
        .sort((a, b) => b.reward - a.reward)
        .slice(0, narrowScreens ? 10 : 25);
    // Surveys rank by conversion rate (payout breaks ties) so TOP PICK is
    // honest. Falls back to payout order if CPX omits conversion fields.
    const byConversion = (a, b) =>
      (Number(b.conversionRate ?? b.conversion_rate ?? 0) - Number(a.conversionRate ?? a.conversion_rate ?? 0)) ||
      (Number(b.payout || 0) - Number(a.payout || 0));
    const sortedSurveys = [...surveys].sort(byConversion);
    const visibleSurveys = narrowScreens ? sortedSurveys.slice(0, 10) : sortedSurveys;

    const getSliderSettings = (itemCount) => {
        const desktopSlides = Math.min(4, Math.max(itemCount, 1));
        const mobileSlides = Math.min(1, Math.max(itemCount, 1));
        const slidesToShow = isMobile ? mobileSlides : desktopSlides;
        return {
            dots: false,
            infinite: itemCount > slidesToShow,
            speed: 500,
            slidesToShow,
            slidesToScroll: slidesToShow,
            responsive: [
                {
                    breakpoint: 1070,
                    settings: {
                        slidesToShow: Math.min(2, Math.max(itemCount, 1)),
                        slidesToScroll: Math.min(2, Math.max(itemCount, 1)),
                        infinite: itemCount > 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        dots: true,
                    }
                },
                {
                    breakpoint: 425,
                    settings: {
                        slidesToShow: mobileSlides,
                        slidesToScroll: mobileSlides,
                        infinite: itemCount > 1,
                        arrows: false,
                        dots: true,
                    }
                }
            ]
        };
    };

    const gamesSliderSettings = getSliderSettings(topGames.length);
    const surveysSliderSettings = getSliderSettings(visibleSurveys.length);
    const visibleOffers = filterOffersByDeviceFilter(offers, deviceFilter);
    const topOffers = [...visibleOffers]
        .sort((a, b) => b.reward - a.reward)
        .slice(0, narrowScreens ? 10 : 25);
    const offersSliderSettings = getSliderSettings(topOffers.length);

    return (
        <div className={classes.pageContainer}>
        <CategorySelector />
        <DeviceFilter value={deviceFilter} onChange={setDeviceFilter} />
        <JackpotStrip games={topGames} surveys={surveys} />
        <h2 className={classes.sponsoredOffersHeading}>Best Games Right Now</h2>
        <hr className={classes.line}/>
        <Slider key={`games-${topGames.length}`} {...gamesSliderSettings}>
                {topGames.map((offer, index) => (
                    <div key={offer.id}>
                        <TopOffer
                            title_text={offer.title}
                            center_text={offer.description}
                            image_game={offer.imageUrl}
                            devices={offer.devices}
                            image_Trophy={'/trophy.png'}
                            link={offer.link}
                            reward_payout={offer.reward}
                            events={offer.events}
                            rank={index}
                            isHot={index === 0}
                            playingNow={getPlayingNow(offer, index)}
                            glimmer
                        />
                    </div>
                ))}
                </Slider>
              <h2 className={classes.sponsoredOffersHeading}>Top Offers</h2>
              <hr className={classes.line}/>
              <Slider key={`offers-${topOffers.length}`} {...offersSliderSettings}>
                      {topOffers.map(offer => (
                          <div key={offer.id}>
                              <TopOffer
                                  title_text={offer.title}
                                  center_text={offer.description}
                                  image_game={offer.imageUrl}
                                  devices={offer.devices}
                                  image_Trophy={'/trophy.png'}
                                  link={offer.link}
                                  reward_payout={offer.reward}
                                  events={offer.events}
                              />
                          </div>
                      ))}
                  </Slider>
        <h2 className={classes.sponsoredOffersHeading}>Top Surveys</h2>
        <hr className={classes.line}/>
        <Slider key={`surveys-${visibleSurveys.length}`} {...surveysSliderSettings}>
            {visibleSurveys.map((survey, index) => (
                <div key={survey.id}>
                    <TopOffer
                        title_text={survey.title || "CPX Research Survey"}
                        center_text={"Complete this survey to earn cash!"}
                        devices={['*']}
                        link={survey.href_new}
                        reward_payout={survey.payout}
                        events={[{
                            eventDescription: "Complete the survey!",
                            value: survey.payout
                        }]}
                        isHot={index === 0}
                        hotLabel="⭐ TOP PICK"
                        ratingsCount={survey.statistics_rating_count}
                        ratingsAvg={survey.statistics_rating_avg}
                        glimmer
                        directLink
                    />
                </div>
            ))}
        </Slider>

    </div>
    )
}